import { Swiper } from './swiper';

const testimonialContainer = document.querySelector('.testimonial-slider__container');
const testimonialsSlider = testimonialContainer?.querySelectorAll('.testimonial-slider .testimonial-slider__slide')

if (testimonialsSlider?.length > 0) {
    (function (swiper) {
        let itemPerSlide = testimonialContainer
            .querySelector('[data-item-per-slide]')
            ?.getAttribute('data-item-per-slide')

        if (window.innerWidth < 991) {
            itemPerSlide = 1;
        }

        return new swiper(testimonialContainer, {
            loop: true,
            slidesPerView: itemPerSlide ? parseInt(itemPerSlide) : 1,
            spaceBetween: 0.5,
            navigation: {
                nextEl: ".testimonial-slider-next",
                prevEl: ".testimonial-slider-prev",
            },
        });
    })(Swiper)
}




